import router from '@/router/router';
import cloneDeep from 'clone-deep';

export const Route = {
    state: {},
    mutations: {},
    getters: {
        getCurrentRoute(state, getters, rootState) {
            if (rootState.route) {
                return rootState.route;
            }
        },
        getCurrentRoutePath(state, getters, rootState) {
            if (rootState.route && rootState.route.path) {
                return rootState.route.path;
            }
        },
        getCurrentRouteFullPath(state, getters, rootState) {
            if (rootState.route && rootState.route.fullPath) {
                return rootState.route.fullPath;
            }
        },
        getCurrentRouteQuery(state, getters, rootState) {
            if (rootState.route && rootState.route.query) {
                return rootState.route.query;
            }
        },
        getTecpageApiUrl() {
            return process.env.VUE_APP_API_TECPAGE_URL;
        },
        getDehaApiUrl() {
            return process.env.VUE_APP_API_DEHA_URL;
        }
    },
    actions: {
        async routeAddQuery(context, payload) {
            let query = cloneDeep(context.rootState.route.query);
            Object.entries(payload).forEach(([key, value]) => {
                query[key] = value;
            });
            await new Promise((resolve) => {
                router.push(
                    { query: query },
                    () => {
                        resolve();
                    },
                    () => {
                        resolve();
                    }
                );
            });
        },
        async routeRemoveQuery(context, payload) {
            let query = cloneDeep(context.rootState.route.query);
            payload.forEach((value) => {
                delete query[value];
            });
            await new Promise((resolve) => {
                router.push(
                    { query: query },
                    () => {
                        resolve();
                    },
                    () => {
                        resolve();
                    }
                );
            });
        },
        async routeRemoveAllQueries() {
            await new Promise((resolve) => {
                router.push(
                    { query: {} },
                    () => {
                        resolve();
                    },
                    () => {
                        resolve();
                    }
                );
            });
        }
    }
};
